module.exports = __webpack_public_path__ + "img/rock.499a0fa1.svg";